export const SEND_OPEN_POOL_REQUESTS_FAILURE = 'SEND_OPEN_POOL_REQUESTS_FAILURE';

export const sendOpenPoolRequestsFailure = error => ({
    type: SEND_OPEN_POOL_REQUESTS_FAILURE,
    payload: error,
    error: true,
});
